import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// The browser's own scroll-restoration ("auto" by default) tries to
// remember/restore scroll position per history entry and can fight with
// ScrollToTop's programmatic reset on route changes — a well-known SPA
// gotcha where the manual scroll-to-top gets silently overridden. Hand
// scroll position management entirely to the app instead.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
